import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Wishlist/WishlistInfoblock/WishlistInfoblock.container"
    ).then((module) => ({
        default: module.WishlistInfoblockContainer
    }))
);
